// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nrrjivvsspffxmezavms.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5ycmppdnZzc3BmZnhtZXphdm1zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5MjE2NzAsImV4cCI6MjA2NTQ5NzY3MH0.g5MPxaG72TSkWliEez12fg_OLqXcY5CqpEEiDe5Hhhg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);